<template>
  <div class="panel-item" :class="itemClass(type)">
    <div class="price">{{ numberFormat(difference) }}</div>
    <div class="content">
      <div class="description">
        <span class="main">{{ description }}</span>
        <small v-if="subDescription" class="sub">{{ subDescription }}</small></div>
    </div>
    <div class="datetime">{{ datetime.toLocaleString() }}</div>
  </div>
</template>

<style lang="scss" scoped>
@import "../../../styles/media_query_mixins.scss";

.panel-item {
  display: flex;
  align-items: center;
  border-bottom: 1px #ddd solid;
  padding: 10px 0;

  &.type-acquire {
    .price {
      color: #008800;
    }
  }
  &.type-exchange, &.type-coin_exchange {
    .price {
      color: #0000bb;
    }

    &.pending {
      .price {
        color: #b4b4e0;
      }
    }
  }
  &.type-exchange_pending {
    .price {
      color: #b4b4e0;
    }
  }
  &.type-expire {
    .price {
      color: #8f8f8f;
    }
  }

  .price {
    font-size: 2em;
    flex-basis: 4em;
    width: 4em;
    text-align: right;
    margin-right: 10px;
  }

  .content {
    flex-grow: 1;

    @include size-lg {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .description {
      .main, .sub {
        display: block;
      }
      small {
        font-size: 0.8em;
        color: #777;
      }
    }
  }

  .datetime {
    text-align: right;
    font-size: 0.8em;
    color: #888;
  }
}
</style>

<script>
import { JewelHistoryType } from '../../../lib/Api'

export default {
  name: 'jewel-history-list-item',
  props: {
    difference: Number,
    type: String,
    exchangedAt: Date,
    calculationForDate: Date,
    datetime: Date
  },
  computed: {
    description () {
      switch (this.type) {
        case JewelHistoryType.ACQUIRE:
          return this.$t('home.jewelHistoryTable.transactionType.acquire')
        case JewelHistoryType.EXCHANGE:
          return this.$t('home.jewelHistoryTable.transactionType.exchangeRequest')
        case JewelHistoryType.EXPIRE:
          return this.$t('home.jewelHistoryTable.transactionType.expire')
        case JewelHistoryType.COIN_EXCHANGE:
          return this.$t('home.jewelHistoryTable.transactionType.coinExchange')
        default:
          return this.type
      }
    },
    subDescription () {
      switch (this.type) {
        case 'acquire':
          return this.$t('home.jewelHistoryTable.acquiredAt', { date: this.calculationForDate.toLocaleDateString() })
        case 'exchange':
          if (this.exchangedAt) {
            return this.$t('home.jewelHistoryTable.exchangedAt', { date: this.exchangedAt.toLocaleDateString() })
          } else {
            return null
          }
        default:
          return null
      }
    }
  },
  methods: {
    itemClass (itemType) {
      let classes = [`type-${itemType}`]
      if (this.type === 'exchange' && !this.exchangedAt) {
        classes.push('pending')
      }

      return classes
    },
    numberFormat (num) {
      const numStr = num.toLocaleString()

      if (num > 0) {
        return `+${numStr}`
      } else {
        return numStr
      }
    }
  }
}
</script>
